import angular from 'angular';
import creditCheckHistory from './creditCheckHistory';

export default angular
  .module('components.creditCheckHistory', [])
  .component('creditCheckHistory', creditCheckHistory).name;
